import { Deserializable } from '../../../../protocols/deserializable';
import { UpdateEmploymentStatusSubmissionData } from './update-employment-status-submission-data';

export class UpdateEmploymentStatusSubmission implements Deserializable {
  public new!: UpdateEmploymentStatusSubmissionData;
  public previous!: UpdateEmploymentStatusSubmissionData;

  public onDeserialize(): void {
    if (this.new) {
      this.new = window.injector.Deserialize.instanceOf(UpdateEmploymentStatusSubmissionData, this.new);
    }

    if (this.previous) {
      this.previous = window.injector.Deserialize.instanceOf(UpdateEmploymentStatusSubmissionData, this.previous);
    }
  }
}
